import * as React from 'react'
import { Grid2 } from '@mui/material'
import Navbar from '../setup/Navbar'
import HeadingText from '../../BuiltInComponent/HeadingTest'
import TextFields from '../../BuiltInComponent/TextField'
import ButtonNormal from '../../BuiltInComponent/ButtonNormal'
import { useDispatch, useSelector } from 'react-redux'
import { addNewItem, getAllIHeads, deleteHead } from '../../features/GeneralManagement/itemHeadsSlice'
import StickyHeadTable from '../../BuiltInComponent/TableWithPagination'
import Loading from '../../BuiltInComponent/Loading'

export default function ItemHeads() {

    const dispatch = useDispatch()

    const { heads, isLoading } = useSelector((state) => state.ih)

    React.useEffect(() => {
        dispatch(getAllIHeads())
    }, [dispatch])
    const [itemHeads, setItemHeads] = React.useState({
        headDescription: ''
    })

    const onChange = (data) => {
        const keys = Object.keys(data)
        setItemHeads(prevData => ({
            ...prevData,
            [keys[0]]: data[keys[0]]
        }))
    }

    const onClick = async () => {

        await dispatch(addNewItem(itemHeads))
            .then(() => {
                dispatch(getAllIHeads())
            })
    }

    const tableColumns = [
        { fieldName: 'headCode', cName: 'Item Code', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'headDescription', cName: 'Description', textAlign: 'left', width: 300, status: 'en', dType: 'string' },
        { fieldName: 'Edit', cName: 'Edit', textAlign: 'right', width: 20, status: 'dis', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'center', width: 20, status: 'en', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'right', width: 80, status: 'dis', dType: 'string' },
    ];

    const onEditClick = async (itemCode) => {

    }

    const onDeleteClick = async (itemCode) => {
        console.log(itemCode)
        await dispatch(deleteHead({ itemCode: itemCode }))
            .then(() => {
                dispatch(getAllIHeads())
            })

        // await dispatch(getAllItems())
    }
    return (
        <>
            <Navbar />
            <Grid2 container spacing={2} sx={{ padding: '20px' }}>
                <Grid2 size={4}></Grid2>
                <Grid2 size={4}><HeadingText text='Item Heads' /></Grid2>
                <Grid2 size={4}></Grid2>

                <Grid2 size={4}></Grid2>
                <Grid2 size={4}>
                    {/* <TextField value={itemHeads.headDescription} onChange={(e) => { setItemHeads({ headDescription: e.target.value }) }} /> */}
                    <TextFields
                        label='Item Heads'
                        id='headDescription'
                        name='headDescription'
                        value={itemHeads.headDescription} onChange={onChange} />
                </Grid2>
                <Grid2 size={4}></Grid2>
                <Grid2 size={4}></Grid2>
                <Grid2 size={4}>
                    <ButtonNormal text='Add New Heads' onClick={onClick} />
                </Grid2>
                <Grid2 size={4}></Grid2>
                <Grid2 size={4}></Grid2>
                <Grid2 size={4}>
                    {isLoading && <Loading loadingText='New Added Item' />}
                </Grid2>
                <Grid2 size={4}></Grid2>
                <Grid2 size={4}></Grid2>
                <Grid2 size={4}>
                    <StickyHeadTable tableColumns={tableColumns} tableData={heads && heads}
                        onEditClick={onEditClick} onDeleteClick={onDeleteClick} perPage={10} />
                </Grid2>
                <Grid2 size={4}></Grid2>
            </Grid2>
        </>
    )
}